import Provider from '@/enums/Provider';
import UrlTypes from '@/enums/UrlTypes';
import { classifyKbsUrl } from './kbsUrlClassifier';
import { classifyIoUrl } from './ioUrlClassifier';
import { classifyErsUrl } from './ersUrlClassifier';

/**
 * Determine the sitemap URL type based on the provider.
 */
const determineUrlType = (loc: string, provider: Provider): UrlTypes => {
    switch (provider) {
        case Provider.KBS:
            return classifyKbsUrl(loc);
        case Provider.IO:
            return classifyIoUrl(loc);
        case Provider.ERS:
            return classifyErsUrl(loc);
        default:
            return UrlTypes.OTHER;
    }
};

export default determineUrlType;
